import { Box, styled } from '../../base';

export const StyledApplyNowBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 80px)',
    overflow: 'hidden',
}));

export const StyledApplyNowMiddleContainerBox = styled(Box)(() => ({
    display: 'flex',
    overflow: 'auto',
    flexGrow: 1,
}));
